export default "__VITE_ASSET__CtDGeXqe__"